<template>
  <div class="view-container">
    <div class="extended-filter-block">
      <h2>Мониторинг</h2>
    </div>
    <div class="monitoring-sections">
      <EmotionalDynamicsMonitoring />

      <SoftSkillsDynamics />

      <EmotionalStability />

      <ManagementAnalyticsCards />

      <EiProfileCards />
    </div>
  </div>
</template>

<script>
import EmotionalDynamicsMonitoring from "@/components/Analytics/EmotionalDynamicsMonitoring.vue";
import SmallCardWrapper from "@/components/Widgets/WidgetCard.vue";
import TopEmotionsCard from "@/components/Analytics/TopEmotionCards.vue";
import SoftSkillsDynamics from "@/components/Analytics/SoftSkillsDynamics.vue";
import EmotionalStability from "@/components/Analytics/EmotionalStabillity.vue";
import DomainsDonutChart from "@/components/Analytics/DomainsDonutChart.vue";
import ManagementAnalyticsCards from "@/components/Analytics/ManagementAnalyticsCard.vue";
import EiProfileCards from "@/components/Analytics/EiProfilesCards.vue";
import {onBeforeMount} from "@vue/runtime-core";
import {useStore} from "vuex";

export default {
  components: {
    EiProfileCards,
    ManagementAnalyticsCards,
    DomainsDonutChart,
    EmotionalStability, SoftSkillsDynamics, TopEmotionsCard, SmallCardWrapper, EmotionalDynamicsMonitoring},
  setup() {
    const store = useStore();

    onBeforeMount(() => {
      store.dispatch("group/getGroups");
    });
  }
}
</script>

<style scoped lang="scss">
.extended-filter-block {
  display: none;

  @media (max-width: $mobile-breakpoint) {
    margin: 24px 0;
    display: flex;
    column-gap: 25px;
    align-items: center;
    justify-content: space-between;
  }
}

.extended-filter-block h2 {
  font-size: 20px;
  margin-bottom: 0;
}

.monitoring-sections {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
</style>